export default {
    namespaced: true,
    state () {
        return {
            items: [],
            totals: {
                discount: 0,
                discount_percentage: 0,
                subtotal: 0,
                total: 0,
                quantity: 0,
                count: 0
            }
        }
    },
    mutations: {
        init (state, data) {
            for (const [key, value] of Object.entries(data)) {
                state[key] = value;
            }
        }
    }
}
